
import Vue from 'vue';
import api from '@/rest-api';
import { IngestBox } from '@/model';
import HtmlTable from '@/components/HtmlTable.vue';

export default Vue.extend({
  name: 'DocumentTableBox',
  components: { HtmlTable },

  props: {
    box: { type: Object as () => IngestBox, required: true },
  },

  data() {
    return {
      showImage: false,
    };
  },

  computed: {
    imageSrc(): string {
      return this.box.file ? api.fileDownloadUri(this.box.file) : '';
    },
  },
});
